import React, { useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './AccessoriesProducts.css';
import ProductModal from './ProductModal';
import b1 from './assets/belt/b1.jpg';
import b3 from './assets/belt/b3.jpg';
import b5_1 from './assets/belt/b5_1.jpg';
import b5_2 from './assets/belt/b5_2.jpg';
import b6 from './assets/belt/b6.jpg';
import bap271 from './assets/belt/BAP271.png';
import bap272 from './assets/belt/BAP272.png';
import bap273 from './assets/belt/BAP273.png';
import bap274_p1 from './assets/belt/BAP274_p1.png';
import bap274_p2 from './assets/belt/BAP274_p2.png';
import bap275 from './assets/belt/BAP275.png';
import bap276_p1 from './assets/belt/BAP276_p1.png';
import bap276_p2 from './assets/belt/BAP276_p2.png';
import bap277 from './assets/belt/BAP277.png';

const Belts = () => {
  const [selectedProduct, setSelectedProduct] = React.useState(null);
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const openProduct = (name, image) => {
    setSelectedProduct({ name, image, category: "BELTS COLLECTION" });
    setIsModalOpen(true);
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  const createCard = (images, title) => (
    <div 
      className="card" 
      onClick={(e) => {
        if (e.target.closest('.slick-arrow') || e.target.closest('.slick-dots')) {
          return;
        }
        openProduct(title, images);
      }}
    >
      {images.length > 1 ? (
        <Slider {...settings}>
          {images.map((img, index) => (
            <div key={index}><img src={img} alt={`${title} - ${index + 1}`} /></div>
          ))}
        </Slider>
      ) : (
        <div><img src={images[0]} alt={`${title} - 1`} /></div>
      )}
      <h3>{title}</h3>
    </div>
  );


  return (
    <div className="category-container">
      <h2>Belts</h2>
      <div className="card-container">
        {createCard([b1], "PPA 18")}
        {createCard([b3], "PPA 12")}
        {createCard([b5_1, b5_2], "AN 201")}
        {createCard([b6], "SA 23")}
        {createCard([bap271], "BAP 271")}
        {createCard([bap272], "BAP 272")}
        {createCard([bap273], "BAP 273")}
        {createCard([bap274_p1, bap274_p2], "BAP 274")}
        {createCard([bap275], "BAP 275")}
        {createCard([bap276_p1, bap276_p2], "BAP 276")}
        {createCard([bap277], "BAP 277")}
      </div>
      <ProductModal 
        product={selectedProduct} 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </div>
  );
};

export default Belts;
